<template>
  <b-modal
    id="locker-code-modal"
    size="lg"
    centered
    hide-footer
    hide-header
    content-class="locker-access-modal"
  >
    <button
      class="close-button"
      @click="closeViewer()"
    >
      <i class="fas fa-times" />
    </button>
    <div class="locker-access-content">
      <h5
        v-if="!isNotAvailableYet"
        class="modal-title mb-1"
      >
        {{ $t('lang.lockers.scan_qr_code') }}
      </h5>

      <div
        v-if="isLoading"
        class="locker-code-loading"
      >
        <b-spinner
          variant="primary"
          :label="$t('lang.lockers.loading_access_codes')"
        />
        <p class="mt-3 mb-0">
          {{ $t('lang.lockers.loading_access_codes') }}
        </p>
      </div>

      <h5
        v-else-if="isNotAvailableYet"
        class="empty-message"
      >
        {{ $t('lang.lockers.access_code_available_booking_day') }}
      </h5>

      <VueperSlides
        v-else-if="accessCodes.length"
        class="no-shadow locker-code-carousel activities"
        fixed-height="500px"
        :visible-slides="1"
        :bullets="accessCodes.length > 1"
        :arrows="accessCodes.length > 1"
        :touchable="accessCodes.length > 1"
        :dragging-distance="50"
      >
        <VueperSlide
          v-for="(accessCode, index) in accessCodes"
          :key="accessCode.id || index"
        >
          <template #content>
            <div class="locker-code-slide">
              <h6 class="locker-code-title">
                <span v-if="accessCode.box_id">
                  {{ $t('lang.lockers.locker_number', { number: accessCode.box_id }) }} -
                </span>{{ $t('lang.lockers.locker_size', { size: accessCode.size }) }}
              </h6>

              <figure class="qrcode-wrapper">
                <VueQrcode
                  :value="accessCode.qr_content"
                  tag="svg"
                  :options="options"
                  class="qrcode"
                />
              </figure>

              <div
                v-if="accessCode.access_code"
                class="mb-3"
              >
                <h6 class="access-code">
                  {{ $t('lang.lockers.enter_screen') }}
                </h6>
                <!--                <h6-->
                <!--                  v-if="accessCode.document_digits"-->
                <!--                  class="access-code"-->
                <!--                >-->
                <!--                  {{ $t('lang.lockers.enter_doc') }}-->
                <!--                  <strong>0000</strong>-->
                <!--                </h6>-->
                <h6 class="access-code">
                  {{ $t('lang.lockers.enter_access_code') }}
                </h6>
                <h4>{{ accessCode.access_code }}</h4>
              </div>
            </div>
          </template>
        </VueperSlide>
      </VueperSlides>

      <p
        v-else
        class="empty-message"
      >
        {{ $t('lang.lockers.no_access_codes') }}
      </p>
    </div>
  </b-modal>
</template>
<script>
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { VueperSlide, VueperSlides } from 'vueperslides';
import '@/assets/css/custom-vueper-slide.css';

export default {
  name: 'LockerAccessCodeModal',
  components: {
    VueQrcode,
    VueperSlides,
    VueperSlide,
  },
  props: {
    accessCodes: {
      type: Array,
      required: false,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isNotAvailableYet: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: {
        width: 250,
        margin: 1,
        color: {
          dark: '#051460',
          light: '#ffffff',
        },
      },
    };
  },

  methods: {
    closeViewer() {
      this.$bvModal.hide('locker-code-modal');
    },
  },
};
</script>
<style scoped>
.locker-access-content {
  padding: 30px 24px 10px;
  text-align: center;
}

.modal-title {
  margin-bottom: 18px;
  color: var(--secondary-color);
  font-weight: bold;
}

.locker-code-carousel {
  margin: 0 auto;
  max-width: 520px;
}

.locker-code-slide {
  display: flex;
  min-height: 390px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 8px 32px 34px;
}

.locker-code-loading {
  display: flex;
  min-height: 260px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #555;
}

.qrcode-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 292px;
  height: 292px;
  margin: 0 auto 15px;
  padding: 18px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 10px 24px rgba(5, 20, 96, .12);
}

.qrcode{
  width: 250px;
  height: 250px;
  max-width: 100%;
}

.empty-message {
  margin: 22px 0 8px;
  color: #666;
}

.close-button {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 50%;
  background: rgba(5, 20, 96, .08);
  color: var(--secondary-color);
  cursor: pointer;
  font-size: 16px;
  line-height: 34px;
  text-align: center;
  z-index: 10000;
}

.close-button:hover {
  background: var(--main-color);
  color: #fff;
}

@media (max-width: 575px) {
  .locker-access-content {
    padding: 26px 15px 10px;
  }

  .locker-code-slide {
    padding-right: 24px;
    padding-left: 24px;
  }

  .qrcode-wrapper {
    width: 280px;
    height: 280px;
    padding: 14px;
  }

  .qrcode {
    width: 250px;
    height: 250px;
  }
}
</style>
